import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import Syllabus from 'modules/trainings/components/content/Syllabus'

export default function ContentOverviewPage() {
  const { trainingId } = useStrictParams<'trainingId'>()
  const { employee: currentEmployee } = useCurrentSession()
  return (
    <Box gap="s8">
      <h2 className="text-lg font-semibold text-f1-foreground">
        {i18n.t('trainings.my_trainings_revamp.training_detail.content')}
      </h2>
      <Syllabus trainingId={Number(trainingId)} employeeId={currentEmployee.id} />
    </Box>
  )
}
